import { useQuery } from '@tanstack/react-query';

import { acceso360Client } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { TClient } from '../types';

import { clientQueryKeys } from './query-keys';

export async function getClients(): Promise<TClient[]> {
  return acceso360Client.get(`/monitoring/api/v1/clients`).then(({ data }) => data);
}

type QueryFnType = typeof getClients;

interface UseClientsParams {
  config?: QueryConfig<QueryFnType>;
}

export function useClients({ config = {} }: UseClientsParams = {}) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: clientQueryKeys.clientList(),
    queryFn() {
      return getClients();
    },
  });
}
